module.exports = __webpack_public_path__ + "static/img/weixinzhifu.3324a98b.png";